import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Button,
  Box,
  Card,
  CardContent,
  Divider,
  Modal,
  Typography
} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';

const MonthlyVATTable = (props) => {

  const columns = [
    { field: 'displayId', headerName: 'ID', flex: 1, sortable: false },
    { field: 'createdAt', headerName: 'Date', flex: 1, sortable: false },
    { field: 'amountBeforeVat', headerName: 'Amount before VAT', flex: 1, sortable: false },
    { field: 'vat', headerName: 'VAT', flex: 1, sortable: false },
    { field: 'total', headerName: 'Total Amount', flex: 1, sortable: false }
  ];

  const [vatOutTableData, setVatOutTableData] = useState([]);
  const [vatInTableData, setVatInTableData] = useState([]);

  useEffect(() => {
    let vatOutBuffer = [];
    let vatInBuffer = [];
    
    const startDate = moment([ moment().year(), props.month ]);
    const endDate = moment([ moment().year(), props.month ]).add(1, 'month');

    while (startDate.isBefore(endDate)) {

      // OUT
      // Sales Orders
      for ( let i = 0; i < props.salesOrders.length; i++ ) {
        const currSalesOrder = props.salesOrders[i];
        for ( let j = 0; j < currSalesOrder.payments.length; j++ ) {
          if(startDate.isSame(currSalesOrder.payments[j].createdAt, 'day')) {
            const payment = currSalesOrder.payments[j];
            vatOutBuffer.push({
              displayId: payment.displayId,
              createdAt: moment(payment.createdAt).format('DD/MM/YYYY'),
              amountBeforeVat: payment.amount - payment.amountVat,
              vat: payment.amountVat,
              total: payment.amount
            });
          }
        }
      }

      // IN
      // Expenses
      for ( let i = 0; i < props.expenses.length; i++ ) {
        if (startDate.isSame(props.expenses[i].createdAt, 'day') && props.expenses[i].totalVat) {
          const expense = props.expenses[i];
          vatInBuffer.push({
            displayId: expense.displayId,
            createdAt: moment(expense.createdAt).format('DD/MM/YYYY'),
            amountBeforeVat: expense.total - expense.totalVat,
            vat: expense.totalVat,
            total: expense.total
          });
        }
      }

      startDate.add(1, 'day');
    }
    
    setVatOutTableData(vatOutBuffer);
    setVatInTableData(vatInBuffer);
    
  }, [props.salesOrders, props.expenses, props.month]);

  return (
    <Modal open={props.open}>
      <Card>
        <CardContent>
          <Box>
            <Typography
              color="textPrimary"
              variant="h5"
            >
              Month Report : {moment([ moment().year(), props.month ]).format('MMMM/YYYY')}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              columnGap: 40,
              marginBottom: '1%'
            }}
          >
            <Typography
              color="textPrimary"
              variant="h6"
            >
              VAT OUT : {vatOutTableData.reduce((prev, curr) => prev + curr.vat, 0)} AED
            </Typography>
            <Typography
              color="textPrimary"
              variant="h6"
            >
              VAT IN : {vatInTableData.reduce((prev, curr) => prev + curr.vat, 0)} AED
            </Typography>
            <Typography
              color="textPrimary"
              variant="h6"
            >
              PAYABLE VAT : {vatOutTableData.reduce((prev, curr) => prev + curr.vat, 0) - vatInTableData.reduce((prev, curr) => prev + curr.vat, 0)} AED
            </Typography>
          </Box>
          <Divider/>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '1%'
            }}
          >
            <Box
              sx={{
                height: 474,
                width: '100%'
              }}
            >
              {/* VAT OUT */}
              <Typography
                align="center"
                color="textPrimary"
                variant="h5"
              >
                VAT OUT
              </Typography>
              <DataGrid
                rows={vatOutTableData}
                columns={columns}
                getRowId={(row) => row.displayId}
                disableSelectionOnClick
                disableColumnMenu
                hideFooter
                localeText={{
                  noRowsLabel: 'No Transactions'
                }}
              />
            </Box>
            <Box
              sx={{
                height: 474,
                width: '100%'
              }}
            >
              {/* VAT IN */}
              <Typography
                align="center"
                color="textPrimary"
                variant="h5"
              >
                VAT IN
              </Typography>
              <DataGrid
                rows={vatInTableData}
                columns={columns}
                getRowId={(row) => row.displayId}
                disableSelectionOnClick
                disableColumnMenu
                hideFooter
                localeText={{
                  noRowsLabel: 'No Transactions'
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '2%'
            }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={props.closeModal}
            >
              Close
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  )
};

export default MonthlyVATTable;